import React from "react";
import { Phone, Mail, MapPin, Clock, ArrowUpRight } from "lucide-react";
import { CONTACT, OPEN_PLAY, BOOKING_URL } from "../../mock/mock";
import { Reveal, SplitWords } from "../motionHelpers";
import { useSettings } from "../useSiteData";

export default function Contact() {
  const settings = useSettings();
  const contact = { ...CONTACT, ...(settings?.contact || {}) };
  const hours = settings?.hours?.length ? settings.hours : OPEN_PLAY.slots;
  return (
    <section id="visit" className="d2-mesh d2-grain py-24 md:py-32 relative overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-5 lg:px-8 relative">
        <div className="mb-14">
          <span className="font-grotesk uppercase tracking-[0.3em] text-sc-lime text-sm">Come Play</span>
          <h2 className="font-display uppercase text-white text-5xl md:text-8xl leading-[0.88] mt-3">
            <SplitWords text="Visit Us" />
          </h2>
        </div>

        <div className="grid lg:grid-cols-5 gap-6 items-stretch">
          <Reveal className="lg:col-span-3">
            <div className="rounded-2xl overflow-hidden border border-white/10 h-full min-h-[340px]">
              <iframe title="map" className="w-full h-full min-h-[340px]" loading="lazy" src={`https://www.google.com/maps?q=${encodeURIComponent(contact.mapQuery)}&output=embed`} />
            </div>
          </Reveal>

          <Reveal delay={0.12} className="lg:col-span-2">
            <div className="bg-[#0b241a] border border-white/10 rounded-2xl p-8 md:p-10 h-full flex flex-col">
              <div className="space-y-4 font-grotesk">
                <Info icon={MapPin}>{contact.addressLine1}, {contact.addressLine2}</Info>
                <Info icon={Phone}>{contact.phone}</Info>
                <Info icon={Mail}>{contact.email}</Info>
                <div className="flex items-start gap-3 text-white/75">
                  <Clock className="w-4 h-4 text-sc-lime mt-1 shrink-0" />
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-5 gap-y-0.5 text-sm">
                    {hours.map((h) => (
                      <span key={h.day} className="whitespace-nowrap"><span className="text-white/50">{h.day.slice(0, 3)}</span> {h.time}</span>
                    ))}
                  </div>
                </div>
              </div>
              <div className="mt-8 pt-6 border-t border-white/10">
                <p className="font-grotesk uppercase tracking-widest text-xs text-sc-lime mb-2">{OPEN_PLAY.title}</p>
                <p className="text-white/60 text-sm font-grotesk">Rated open play runs all day, every day. Reserve a court or drop in.</p>
                <a href={BOOKING_URL} className="d2-btn inline-flex items-center gap-2 px-7 py-3 mt-5 text-sm w-full justify-center">Book Now! <ArrowUpRight className="w-4 h-4" /></a>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}

function Info({ icon: Icon, children }) {
  return (
    <div className="flex items-start gap-3 text-white/75">
      <Icon className="w-4 h-4 text-sc-lime mt-1 shrink-0" /><span>{children}</span>
    </div>
  );
}
